import renderTestimonialsForm from 'src/routes/TestimonialsForm/renderTestimonialsForm';

renderTestimonialsForm();
